import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Router, Switch, Route, Redirect } from "react-router-dom";
import { Link } from "react-router-dom";
import "../src/assets/plugins/bootstrap/css/bootstrap.min.css";
import Login from "./components/auth/Login";
import Dashboard from "./components/auth/Dashboard";
import CardHolders from "./components/cardholders/CardHolders";
import ClientAdmin from "./components/clilentadmin/ClientAdmin";
import SuperAdmin from "./components/superadmin/SuperAdmin";
import Navigation from "./components/navigation/nav";
import { logout } from "./actions/auth";
import { clearMessage } from "./actions/message";
import ResetPassword from "./components/account/resetpassword";
import { history } from "./helpers/history";
import ForgotPassword from "./components/account/ForgotPassword";
import IdentityVerification from "./components/account/IdentityVerification";
import TwoFAVerification from "./components/account/TwoFAVerification";
import ClientSignup from "./components/clilentadmin/ClientSignup";
import CardHolderDetails from "./components/cardholders/CardHolderDetails";
import ClientCards from "./components/superadmin/ClientCards";
import Verification from "./components/verification/Verification";
import Settings from "./components/superadmin/Settings";
import CardHolderSettings from "./components/cardholders/Settings";
import ClientAdminSettings from "./components/clilentadmin/Settings";
import Help from "./components/Help";
import SuperAdminHelp from "./components/superadmin/SuperAdminHelp";
import DepositClients from "./components/depositscreensClients/DepositClients";
import Transactions from "./components/superadmin/Transactions";
import CardHolderCards from "./components/cardholderCardScreens/CardHolderCards";
import CardHolderTransactions from "./components/cardholderCardScreens/CardHolderTransactions";
import MobileMenu from "./helpers/MobileMenu";
import ThemeSelector from "./helpers/ThemeSelector";
import { useIdleTimer } from "react-idle-timer";
import { haspermissions } from "./components/permissions/PermissionTypes";
import SuperClientDetails from "./components/superclient/SuperClientDetails";
import SubClientDetails from "./components/superclient/SubClientDetail";
import ApiPin from "./components/pinmanagment/APiPin";
var primary;
var secondary;
var lighter1;
var lighter2;
var mainBg;
var menuBg;
var cardBg;
var selectedTab;
var tabHover;
var headingText;
var icon;
var line;
var textBox;
var font;
var defaultcolor="transparent";
const App = () => {
  const { user: currentUser } = useSelector(state => state.auth);
  const dispatch = useDispatch();
  // const [idleTime, setIdleTime] = useState(process.env.REACT_APP_LOGOUT_TIME); //// time in mili seconds for 5 mints
  const [idleTime, setIdleTime] = useState(1000000);
  useEffect(() => {
    history.listen(location => {
      dispatch(clearMessage()); // clear message when changing location
    });
  }, [dispatch]);

  const logOut = () => {
    dispatch(logout());
    removeThemeVariables();
  };
  const addThemeVariables = () => {
    primary = currentUser?.user?.PrimaryColor;
    secondary = currentUser?.user?.SecondaryColor;
    lighter1 = currentUser?.user?.ColorPrimarylighter1;
    lighter2 = currentUser?.user?.ColorPrimarylighter2;
    mainBg = currentUser?.user?.MainBackgroundColor ?? "#fafafa";
    menuBg = currentUser?.user?.MenuBackgroundColor ?? "#fff8fe";
    cardBg = currentUser?.user?.CardBackgroundColor?? "#020002";
    selectedTab = currentUser?.user?.SelectedTabColor?? "#020002";
    tabHover = currentUser?.user?.TabHoverColor??"#020002";
    headingText = currentUser?.user?.HeadingTextColor??"#1a031a";
    icon = currentUser?.user?.IconColor??"#020002";
    line = currentUser?.user?.LineColor??"#020002";
    textBox = currentUser?.user?.TextBoxColor??"#020002";
    font = currentUser?.user?.FontColor??"#020002";
    document.documentElement.style.setProperty("--color-primary", primary);
    document.documentElement.style.setProperty("--color-secondary", secondary);
    document.documentElement.style.setProperty("--color-primary-lighter-1", lighter1);
    document.documentElement.style.setProperty("--color-primary-lighter-2", lighter2);
    document.documentElement.style.setProperty("--color-main-bg", mainBg);
    document.documentElement.style.setProperty("--color-menu-bg", menuBg);
    document.documentElement.style.setProperty("--color-card-bg", cardBg);
    document.documentElement.style.setProperty("--color-selected-tab", selectedTab);
    document.documentElement.style.setProperty("--color-tab-hover", tabHover);
    document.documentElement.style.setProperty("--color-heading-text", headingText);
    document.documentElement.style.setProperty("--color-icon", icon);
    document.documentElement.style.setProperty("--color-line", line);
    document.documentElement.style.setProperty("--color-text-box", textBox);
    document.documentElement.style.setProperty("--color-font", font);
  };
  const removeThemeVariables = () => {
    document.documentElement.style.removeProperty("--color-primary", primary);
    document.documentElement.style.removeProperty("--color-secondary", secondary);
    document.documentElement.style.removeProperty("--color-primary-lighter-1", lighter1);
    document.documentElement.style.removeProperty("--color-primary-lighter-2", lighter2);
    document.documentElement.style.removeProperty("--color-main-bg",mainBg);
    document.documentElement.style.removeProperty("--color-menu-bg",menuBg);
    document.documentElement.style.removeProperty("--color-card-bg",cardBg);
    document.documentElement.style.removeProperty("--color-selected-tab",selectedTab);
    document.documentElement.style.removeProperty("--color-tab-hover",tabHover);
    document.documentElement.style.removeProperty("--color-heading-text",headingText);
    document.documentElement.style.removeProperty("--color-icon",icon);
    document.documentElement.style.removeProperty("--color-line",line);
    document.documentElement.style.removeProperty("--color-text-box",textBox);
    document.documentElement.style.removeProperty("--color-font",font);
  };
  if (currentUser) {
    addThemeVariables();
  }
  const handleOnIdle = (event) => {
    logOut();
  };
  const handleOnActive = (event) => {
    console.log("user is active", event);
    console.log("time remaining", getRemainingTime());
  };

  const handleOnAction = (event) => {
    setIdleTime(idleTime);
  };

  const { getRemainingTime, getLastActiveTime } = useIdleTimer({
    timeout: idleTime,
    onIdle: handleOnIdle,
    onActive: handleOnActive,
    onAction: handleOnAction,
    crossTab: true,
    debounce: 500,
  });
  if (currentUser) {
    if (currentUser?.role == "Client admin") {
      haspermissions.LoadCard = currentUser?.user?.Permissions?.includes("Load Card");
      haspermissions.IssueVirtualCard = currentUser?.user?.Permissions?.includes("Issue Virtual Card");
      haspermissions.IssuePhysicalCard = currentUser?.user?.Permissions?.includes("Issue Physical Card");
      haspermissions.SuspendCard = currentUser?.user?.Permissions?.includes("Suspend Card");
      haspermissions.ViewLedgerBalance = currentUser?.user?.Permissions?.includes("View Ledger Balance");
      haspermissions.ViewLedgerHistory = currentUser?.user?.Permissions?.includes("View Ledger History");
      haspermissions.ViewC2CHistory = currentUser?.user?.Permissions?.includes("View CardHolder Transactions");
      haspermissions.ViewCardholderKYC = currentUser?.user?.Permissions?.includes("View Cardholder KYC");
      haspermissions.DebitCard = currentUser?.user?.Permissions?.includes("Debit Card");
      haspermissions.ApiKey = currentUser?.user?.Permissions?.includes("APIKey");
      //SuperClient Permissions
      haspermissions.SuperClientcardtocard = currentUser?.user?.ClientPermissions?.includes("Card to Card Transfer");
      haspermissions.SuperClientDebitCard = currentUser?.user?.ClientPermissions?.includes("Debit Card");
      haspermissions.SuperClientUserKYC = currentUser?.user?.ClientPermissions?.includes("User KYC");
      haspermissions.SuperClientIssueVirtualCard = currentUser?.user?.ClientPermissions?.includes("Issue Virtual Card");
      haspermissions.SuperClientIssuePhysicalCard = currentUser?.user?.ClientPermissions?.includes("Issue Physical Card");
      haspermissions.SuperClientActivatePhysical = currentUser?.user?.ClientPermissions?.includes("Activate Physical Card");
      haspermissions.SuperClientSuspendCard = currentUser?.user?.ClientPermissions?.includes("Suspend Card");
    }
    if (currentUser?.role == "Super client") {
      haspermissions.LoadCard = currentUser?.user?.Permissions?.includes("Load Card");
      haspermissions.IssueVirtualCard = currentUser?.user?.Permissions?.includes("Issue Virtual Card");
      haspermissions.IssuePhysicalCard = currentUser?.user?.Permissions?.includes("Issue Physical Card");
      haspermissions.SuspendCard = currentUser?.user?.Permissions?.includes("Suspend Card");
      haspermissions.ViewLedgerBalance = currentUser?.user?.Permissions?.includes("View Ledger Balance");
      haspermissions.ViewLedgerHistory = currentUser?.user?.Permissions?.includes("View Ledger History");
      haspermissions.ViewC2CHistory = currentUser?.user?.Permissions?.includes("View CardHolder Transactions");
      haspermissions.ViewCardholderKYC = currentUser?.user?.Permissions?.includes("View Cardholder KYC");
      haspermissions.DebitCard = currentUser?.user?.Permissions?.includes("Debit Card");
      haspermissions.ApiKey = currentUser?.user?.Permissions?.includes("APIKey");
      //SuperClient Permissions
      haspermissions.SuperClientcardtocard = currentUser?.user?.ClientPermissions?.includes("Card to Card Transfer");
      haspermissions.SuperClientDebitCard = currentUser?.user?.ClientPermissions?.includes("Debit Card");
      haspermissions.SuperClientUserKYC = currentUser?.user?.ClientPermissions?.includes("User KYC");
      haspermissions.SuperClientIssueVirtualCard = currentUser?.user?.ClientPermissions?.includes("Issue Virtual Card");
      haspermissions.SuperClientIssuePhysicalCard = currentUser?.user?.ClientPermissions?.includes("Issue Physical Card");
      haspermissions.SuperClientActivatePhysical = currentUser?.user?.ClientPermissions?.includes("Activate Physical Card");
      haspermissions.SuperClientSuspendCard = currentUser?.user?.ClientPermissions?.includes("Suspend Card");
      haspermissions.Deposit = currentUser?.user?.Permissions?.includes("Deposit");
    }

  }

  return (
    <ThemeSelector>
      <Router history={history}>
        {currentUser ? (
          <div className="bo-app-main">
            {/* header */}
            <header className="header-main-outer">
              <section className="header-main">
                <div className="row align-items-center position-relative position-md-static">
                  <div className="col-12 p-static d-flex align-items-center justify-content-center">
                    <div className="div-hamburger">
                      <button
                        className="hamburgers"
                        type="button"
                        onClick={() => {
                          MobileMenu();
                        }}
                      >
                        <span></span>
                        <span></span>
                        <span></span>
                      </button>
                    </div>
                    <div className="logo d-flex align-items-center bo-thumb">
                      <Link to="#">
                        <h3>
                          Control<span>Center</span>
                        </h3>
                      </Link>
                    </div>
                  </div>
                </div>
              </section>
            </header>

            <div className="row minh-row">
              <Navigation
                username={currentUser.user.Name}
                role={currentUser.role}
                logo={currentUser.user.ClientLogoUrl}
                logOut={logOut}
                ViewLedgerBalance={haspermissions.ViewLedgerBalance}
                ViewLedgerHistory={haspermissions.ViewLedgerHistory}
                ClientId={currentUser.user.ClientId}
                Deposit={haspermissions.Deposit}
                Issuer={currentUser?.user?.IssuerName}
                ViewAPIKey={haspermissions.ApiKey}
              />
              <Switch>
                {

                  (currentUser.user.SuperClientId > 0) ? (
                    <Fragment>
                      <Route exact path={["/", "/dashboard"]} component={SuperClientDetails} />

                      <Route
                        exact
                        path="/client/settings"
                        component={ClientAdminSettings}
                      />
                      {
                        haspermissions.ApiKey &&(
                        <Route exact path="/apikeymanagment" component={ApiPin} />)
                      }
                      
                      <Route exact path="/clientdetails" component={SubClientDetails} />
                      <Route exact path="/settings" component={Settings} />
                      <Route
                        exact
                        path="/depositclients"
                        component={DepositClients}
                      />
                      <Route
                        exact
                        path="/cardholderdetails"
                        component={CardHolderDetails}
                      />
                    </Fragment>
                  ) : 
                  (<>
                  
                  (
                          <Fragment>
                              <Route exact path={["/", "/dashboard"]} component={CardHolders} />
                              {
                                haspermissions?.ApiKey && (
                               <Route exact path="/apikeymanagment" component={ApiPin} />
                                )
                              }

                              <Route exact path="/clientadmin" component={ClientAdmin} />
                              <Route exact path="/admin" component={SuperAdmin} />
                              <Route
                                exact
                                path="/cardholderdetails"
                                component={CardHolderDetails}
                              />

                              <Route exact path="/settings" component={Settings} />
                              <Route
                                exact
                                path="/cardHolder/settings"
                                component={CardHolderSettings}
                              />
                              <Route
                                exact
                                path="/client/settings"
                                component={ClientAdminSettings}
                              />
                              <Route exact path="/help" component={Help} />
                              <Route exact path="/admin/help" component={SuperAdminHelp} />
                              <Route exact path="/clientcards" component={ClientCards} />
                              <Route exact path="/transactions" component={Transactions} />
                              <Route
                                exact
                                path="/depositclients"
                                component={DepositClients}
                              />
                              <Route
                                exact
                                path="/cardholdercards"
                                component={CardHolderCards}
                              />
                              <Route
                                exact
                                path="/cardholdertransactions"
                                component={CardHolderTransactions}
                              />
                          </Fragment>
                        )
                  </>)
                }

              </Switch>
            </div>
          </div>
        ) : (
          <section className="bo-form-screens">
            <div className="container-fluid">
              <Switch>
                <Route exact path={["/", "/Login"]} component={Login} />
                <Route exact path="/login" component={Login} />
                <Route
                  exact
                  path="/forgotpassword"
                  component={ForgotPassword}
                />
                <Route exact path="/resetpassword" component={ResetPassword} />
                <Route exact path="/clientSignup" component={ClientSignup} />
                <Route
                  exact
                  path="/identityVerification"
                  component={IdentityVerification}
                />
                <Route
                  exact
                  path="/2FAVerification"
                  component={TwoFAVerification}
                />
                <Route exact path="/verification" component={Verification} />
                <Redirect to={"/login"} />
              </Switch>
            </div>
          </section>
        )}
      </Router>
    </ThemeSelector>
  );
};

export default App;
